<div class="orderDetail width-100 " style="margin-bottom: 20px">
  <div class="width-100" style="flex-direction: row;">
    <div style="line-height: 30px">
      <span class="block width-100 TitilliumWeb-Regular" style="font-size: 18px"> {{'front_profil_ticket.order_for'| translate}}</span>
      <span class="block width-100 TitilliumWeb-Regular "  style="font-size: 24px;font-weight: bolder">{{order.event.name}}</span>
    </div>
    <span class="block width-100 TitilliumWeb-Regular date-color">{{order.event.start_date|datefrench}}  {{'front_profil_ticket.from'| translate}} {{order.event.start_hour |hourpipe}}  {{'front_profil_ticket.to'| translate}} {{order.event.end_hour |hourpipe}}</span>
    <span  class="block width-100 TitilliumWeb-Regular ">{{location(order)}}</span>
    <span class="block  width-100 TitilliumWeb-Regular ">{{'front_profil_ticket.order'| translate}} {{order.id}}</span>
    <span class="block  width-100 TitilliumWeb-Regular " *ngIf="order.roombooking">N° chambre  {{order.roombooking.id}}</span>
    <span class="block  width-100 TitilliumWeb-Regular " *ngIf="order.roombooking">code chambre  {{order.roombooking.code}}</span>
  </div>
  <div class="width-100 text-right text-center-mini margin-top-20-mini " style="align-self: flex-end">
    <div style="display: block;margin-bottom: 10px" *ngIf="showOnlineDeadlineStatut()">
      <div style="display: inline-block!important;text-transform: uppercase;text-align: center;width: 189px">statut de l'échéance</div>
      <br>
      <div style="display: inline-block!important;text-align: center;width: 189px"> <div class="online-dot"></div>En cours</div>
    </div>
    <a href="javascript:void(0);" class="btn1 btn2 action1 contact-organiser" (click)="openContactModal()"><span class="btnText">{{'front_profil_ticket.contact_the_organizer'| translate}}</span> </a>
  </div>
</div>


<div style="text-align: center" *ngIf="order.deadlines.length > 0">
  <button data-toggle="collapse" data-target="#demo" class="dealines" style="padding-top: 3px;padding-bottom: 3px;">votre échéancier  <i class="fa fa-angle-down"></i></button>
  <div id="demo" class="collapse">
    <table class="width-100">
      <tr *ngFor="let deadline of order.deadlines;let idx = index">
        <td>Mensualité N° {{idx+1}}</td>
        <td>{{deadline.date |date:'dd/MM/yyyy'}}</td>
        <td>{{deadline.amount.toFixed(2)}} €</td>
        <td>
          <div *ngIf="deadline.payed && deadline.mailSended">Règlé</div>
          <div *ngIf="!deadline.payed && deadline.mailSended">En cours</div>
          <div *ngIf="!deadline.payed && !deadline.mailSended"><span style="text-transform: uppercase">à</span> venir</div>
        </td>
      </tr>
    </table>
  </div>
</div>
<div style="font-size: 11px;margin-top: 4px" *ngIf="order.deadlines.length > 0">* La date de votre prélèvement est donnée a titre indicatif, elle peut être légèrement modifiée d'1 ou ou 2 jours.</div>

